import { io } from 'socket.io-client'
import { get, writable } from 'svelte/store'

const socket = io(window.location.origin)

let testerData = writable([])
let testers = writable({auto: {}, manual: []})
let version = writable('')

socket.on('message', message => {
    let data = get(testerData)
    if (! data.length) testerData.set(message)
    else {
        data.forEach((obj, i) => { if (obj.tester === message.tester) data[i] = message })
        testerData.set(data)
    }
    get(testerData).sort((a, b) => a.tester.localeCompare(b.tester))
})

socket.on('version', arg => version.set(arg))
socket.on('testers', arg => testers.set(arg))

export { testerData, version, testers }
